<app-breadcrumb
  *ngIf="!isMerchantUser"
  [title]="'merchant-info.common.merchantInfo' | translate"
  [items]="['Dashboard' | translate]"
  [active_item]="'merchant-info.common.merchantInfo' | translate">
</app-breadcrumb>

<div class="ump-root container-fluid" [class.is-editing]="isEditing">
  <a
    class="ump-back"
    [routerLink]="isMerchantUser ? ['/dashboard/dashboard'] : ['/dashboard/merchant-info']">
    <i class="fa fa-arrow-right" aria-hidden="true"></i>
    {{ 'merchant-info.common.back' | translate }}
  </a>

  <section class="ump-hero">
    <div class="ump-hero__identity">
      <div class="ump-avatar" aria-hidden="true">{{ merchantInitials }}</div>
      <div class="ump-hero__text">
        <p class="ump-kicker">{{ 'merchant-info.common.merchantInfo' | translate }}</p>
        <h1>{{ displayMerchantName || ('merchant-info.common.merchantInfo' | translate) }}</h1>
        <div class="ump-hero__meta">
          <span class="ump-meta" *ngIf="IdNumber">
            <i class="fa fa-lock" *ngIf="isMerchantUser" aria-hidden="true"></i>
            {{ 'merchant-info.common.idNumber' | translate }}
            <strong>{{ IdNumber }}</strong>
          </span>
          <span class="ump-meta ump-meta--muted" *ngIf="MerchantAddress">
            <i class="fa fa-map-marker" aria-hidden="true"></i>
            {{ MerchantAddress }}
          </span>
        </div>
      </div>
    </div>

    <div class="ump-hero__aside">
      <div class="ump-control ump-control--company" *ngIf="user_type === 100">
        <span class="ump-label ump-label--inline">{{ 'merchant-info.profile.selectCompany' | translate }}</span>
        <div class="ump-control__field">
          <app-cart [listenForOpenEvent]="false"></app-cart>
        </div>
      </div>
      <div class="ump-hero__actions">
        <button
          *ngIf="!isEditing"
          type="button"
          class="ump-btn ump-btn--primary"
          (click)="enterEditMode()">
          <i class="fa fa-pencil" aria-hidden="true"></i>
          {{ 'merchant-info.common.edit' | translate }}
        </button>
        <ng-container *ngIf="isEditing">
          <span class="ump-editing-badge">{{ 'merchant-info.profile.editing' | translate }}</span>
          <button
            type="button"
            class="ump-btn ump-btn--ghost"
            [disabled]="isSaving"
            (click)="cancelEdit()">
            {{ 'merchant-info.common.cancel' | translate }}
          </button>
        </ng-container>
      </div>
    </div>
  </section>

  <div class="ump-layout" [class.ump-layout--single]="!showSubscriptionSection">
    <section class="ump-card ump-card--settings">
      <div class="ump-card__head">
        <h2>{{ 'merchant-info.profile.preferencesTitle' | translate }}</h2>
      </div>
      <div class="ump-settings">
        <div class="ump-setting">
          <div class="ump-setting__label">
            <span>{{ 'merchant-info.profile.appLanguage' | translate }}</span>
          </div>
          <div class="ump-setting__control ump-setting__control--lang">
            <app-languages></app-languages>
          </div>
        </div>

        <div class="ump-setting">
          <div class="ump-setting__label">
            <span>{{ 'invoices_v2.form.document_language' | translate }}</span>
            <small>{{ 'merchant-info.profile.documentLanguageHint' | translate }}</small>
          </div>
          <div class="ump-setting__control">
            <select
              id="profile_document_language"
              class="ump-input ump-input--control"
              name="documentLanguage"
              [ngModel]="documentLanguage"
              (ngModelChange)="onDocumentLanguageChange($event)">
              <option value="ar">العربية</option>
              <option value="en">English</option>
              <option value="he">עברית</option>
            </select>
          </div>
        </div>

        <div class="ump-setting">
          <div class="ump-setting__label">
            <span>{{ 'merchant-info.profile.reportLanguage' | translate }}</span>
            <small>{{ 'merchant-info.profile.reportLanguageHint' | translate }}</small>
          </div>
          <div class="ump-setting__control">
            <select
              id="profile_report_language"
              class="ump-input ump-input--control"
              name="reportLanguage"
              [ngModel]="reportLanguage"
              (ngModelChange)="onReportLanguageChange($event)">
              <option value="ar">العربية</option>
              <option value="en">English</option>
              <option value="he">עברית</option>
            </select>
          </div>
        </div>

        <label class="ump-setting" *ngIf="isMerchantUser">
          <div class="ump-setting__label">
            <span>{{ 'merchant-info.profile.showAssistant' | translate }}</span>
          </div>
          <span class="ump-switch">
            <input
              type="checkbox"
              [checked]="showAssistantButton"
              (change)="onAssistantToggle($event)" />
            <span class="ump-switch__ui" aria-hidden="true"></span>
          </span>
        </label>

        <a class="ump-setting ump-setting--link" routerLink="/support">
          <div class="ump-setting__label">
            <span>{{ 'merchant-info.profile.supportAndHelp' | translate }}</span>
          </div>
          <i class="fa fa-angle-left ump-setting__chevron" aria-hidden="true"></i>
        </a>
      </div>
    </section>

    <section class="ump-card ump-card--form">
      <div class="ump-card__head">
        <h2>{{ 'merchant-info.profile.accountDetails' | translate }}</h2>
      </div>

      <div class="ump-dl" *ngIf="!isEditing">
        <div class="ump-dl__row">
          <span class="ump-dl__label">
            {{ curentLang === 'en' ? 'Merchant Name (Arabic)' : (curentLang === 'ar' ? 'اسم التاجر (عربي)' : 'שם הסוחר (ערבית)') }}
          </span>
          <span class="ump-dl__value">{{ displayField(MerchantNameAr) }}</span>
        </div>
        <div class="ump-dl__row">
          <span class="ump-dl__label">
            {{ curentLang === 'en' ? 'Merchant Name (English)' : (curentLang === 'ar' ? 'اسم التاجر (إنجليزي)' : 'שם הסוחר (אנגלית)') }}
          </span>
          <span class="ump-dl__value">{{ displayField(MerchantNameEn) }}</span>
        </div>
        <div class="ump-dl__row">
          <span class="ump-dl__label">
            {{ curentLang === 'en' ? 'Merchant Name (Hebrew)' : (curentLang === 'ar' ? 'اسم التاجر (عبري)' : 'שם הסוחר (עברית)') }}
          </span>
          <span class="ump-dl__value">{{ displayField(MerchantNameHe) }}</span>
        </div>
        <div class="ump-dl__row ump-dl__row--full">
          <span class="ump-dl__label">
            {{ curentLang === 'en' ? 'Address' : (curentLang === 'ar' ? 'العنوان' : 'כתובת') }}
          </span>
          <span class="ump-dl__value">{{ displayField(MerchantAddress) }}</span>
        </div>
        <div class="ump-dl__row ump-dl__row--full">
          <span class="ump-dl__label">{{ 'merchant-info.common.idNumber' | translate }}</span>
          <span class="ump-dl__value ump-dl__value--id">
            <i class="fa fa-lock" *ngIf="isMerchantUser" aria-hidden="true"></i>
            {{ displayField(IdNumber) }}
          </span>
          <span class="ump-dl__hint" *ngIf="isMerchantUser">{{ 'merchant-info.common.idNumberReadOnlyHint' | translate }}</span>
        </div>
      </div>

      <form
        *ngIf="isEditing"
        [formGroup]="updateMerchant"
        novalidate
        [ngClass]="{ 'was-validated': validate }"
        class="ump-form">
        <div class="ump-field-grid">
          <div class="ump-field">
            <label class="ump-label" for="merchant_name_ar">
              {{ curentLang === 'en' ? 'Merchant Name (Arabic)' : (curentLang === 'ar' ? 'اسم التاجر (عربي)' : 'שם הסוחר (ערבית)') }}
            </label>
            <input
              id="merchant_name_ar"
              class="ump-input"
              onlyAlphabets
              type="text"
              maxlength="80"
              formControlName="merchant_name_ar"
              [(ngModel)]="MerchantNameAr" />
          </div>

          <div class="ump-field">
            <label class="ump-label" for="merchant_name_en">
              {{ curentLang === 'en' ? 'Merchant Name (English)' : (curentLang === 'ar' ? 'اسم التاجر (إنجليزي)' : 'שם הסוחר (אנגלית)') }}
            </label>
            <input
              id="merchant_name_en"
              class="ump-input"
              onlyAlphabets
              type="text"
              maxlength="80"
              formControlName="merchant_name_en"
              [(ngModel)]="MerchantNameEn" />
          </div>

          <div class="ump-field">
            <label class="ump-label" for="merchant_name_he">
              {{ curentLang === 'en' ? 'Merchant Name (Hebrew)' : (curentLang === 'ar' ? 'اسم التاجر (عبري)' : 'שם הסוחר (עברית)') }}
              <span class="ump-required">*</span>
            </label>
            <input
              id="merchant_name_he"
              class="ump-input"
              onlyAlphabets
              type="text"
              maxlength="80"
              formControlName="merchant_name_he"
              [(ngModel)]="MerchantNameHe" />
            <p class="ump-field-error" *ngIf="updateMerchant.get('merchant_name_he')?.hasError('whitespace') && updateMerchant.get('merchant_name_he')?.touched">
              {{ curentLang === 'en' ? 'Name cannot be empty or spaces only' : (curentLang === 'ar' ? 'الاسم لا يمكن أن يكون فارغاً' : 'השם לא יכול להיות ריק') }}
            </p>
          </div>

          <div class="ump-field ump-field--full">
            <label class="ump-label" for="merchant_address">
              {{ curentLang === 'en' ? 'Address' : (curentLang === 'ar' ? 'العنوان' : 'כתובת') }}
            </label>
            <input
              id="merchant_address"
              class="ump-input"
              type="text"
              maxlength="400"
              formControlName="merchant_address"
              [(ngModel)]="MerchantAddress" />
          </div>

          <div class="ump-field ump-field--full" *ngIf="isAdminUser">
            <label class="ump-label" for="id_number_admin">
              {{ 'merchant-info.common.idNumber' | translate }}
              <span class="ump-required">*</span>
            </label>
            <input
              id="id_number_admin"
              class="ump-input"
              type="text"
              inputmode="numeric"
              maxlength="20"
              formControlName="id_number"
              (keypress)="isNumber($event)"
              [(ngModel)]="IdNumber" />
          </div>

          <div class="ump-field ump-field--full" *ngIf="isMerchantUser">
            <label class="ump-label">{{ 'merchant-info.common.idNumber' | translate }}</label>
            <div class="ump-locked">
              <i class="fa fa-lock" aria-hidden="true"></i>
              <span>{{ displayField(IdNumber) }}</span>
            </div>
            <p class="ump-hint">{{ 'merchant-info.common.idNumberReadOnlyHint' | translate }}</p>
          </div>
        </div>

        <div class="ump-actions">
          <button
            type="button"
            class="ump-btn ump-btn--primary"
            [disabled]="isSaving"
            (click)="updateMerchantById()">
            <i class="fa" [ngClass]="isSaving ? 'fa-spinner fa-spin' : 'fa-check'"></i>
            {{ 'merchant-info.common.saveChanges' | translate }}
          </button>
          <button
            type="button"
            class="ump-btn ump-btn--ghost"
            [disabled]="isSaving"
            (click)="cancelEdit()">
            {{ 'merchant-info.common.cancel' | translate }}
          </button>
        </div>
      </form>
    </section>

    <section class="ump-card ump-card--subscription" *ngIf="showSubscriptionSection">
      <div class="ump-card__head">
        <h2>{{ 'merchant-info.profile.subscriptionTitle' | translate }}</h2>
        <a
          *ngIf="isMerchantUser"
          class="ump-card__link"
          [routerLink]="['/dashboard/invoice-subscriptions']">
          {{ 'merchant-info.profile.manageSubscription' | translate }}
          <i class="fa fa-angle-left" aria-hidden="true"></i>
        </a>
      </div>

      <div *ngIf="v2SubscriptionLoading" class="ump-loading">
        <span class="spinner-border spinner-border-sm"></span>
        {{ curentLang === 'en' ? 'Loading…' : (curentLang === 'ar' ? 'جاري التحميل…' : 'טוען…') }}
      </div>

      <div *ngIf="!v2SubscriptionLoading && v2SubscriptionError" class="ump-alert">
        <i class="fa fa-exclamation-triangle"></i>
        {{ curentLang === 'en' ? 'Could not load subscription.' : (curentLang === 'ar' ? 'تعذر تحميل بيانات الاشتراك.' : 'לא ניתן לטעון את המנוי.') }}
      </div>

      <ng-container *ngIf="!v2SubscriptionLoading && !v2SubscriptionError">
        <p class="ump-empty" *ngIf="!v2SubscriptionStatus?.subscription">
          {{ curentLang === 'en' ? 'No active subscription.' : (curentLang === 'ar' ? 'لا يوجد اشتراك نشط.' : 'אין מנוי פעיל.') }}
        </p>

        <ng-container *ngIf="v2SubscriptionStatus?.subscription as sub">
          <div class="ump-plan">
            <div class="ump-plan__main">
              <span class="ump-plan__label">{{ curentLang === 'en' ? 'Plan' : (curentLang === 'ar' ? 'الخطة' : 'תוכנית') }}</span>
              <strong class="ump-plan__name">{{ getPlanDisplayName(sub.plan) }}</strong>
              <span class="ump-status" [attr.data-tone]="subscriptionTone">
                {{ getSubscriptionStatusLabel(sub.status) }}
              </span>
            </div>
            <div class="ump-plan__days">
              <strong>{{ v2SubscriptionStatus.days_remaining ?? '—' }}</strong>
              <span>{{ curentLang === 'en' ? 'Days left' : (curentLang === 'ar' ? 'أيام متبقية' : 'ימים נותרים') }}</span>
            </div>
          </div>

          <div class="ump-period" *ngIf="sub.start_date || sub.end_date">
            <div *ngIf="sub.start_date">
              <span>{{ curentLang === 'en' ? 'Start' : (curentLang === 'ar' ? 'البداية' : 'התחלה') }}</span>
              <strong>{{ sub.start_date | date : 'dd/MM/yyyy' }}</strong>
            </div>
            <span class="ump-period__line" aria-hidden="true"></span>
            <div *ngIf="sub.end_date">
              <span>{{ curentLang === 'en' ? 'End' : (curentLang === 'ar' ? 'النهاية' : 'סיום') }}</span>
              <strong>{{ sub.end_date | date : 'dd/MM/yyyy' }}</strong>
            </div>
          </div>

          <ng-container *ngIf="getSubscriptionUsage() as usage">
            <div class="ump-usage">
              <div class="ump-usage__row">
                <div class="ump-usage__head">
                  <span>{{ curentLang === 'en' ? 'Documents' : (curentLang === 'ar' ? 'المستندات' : 'מסמכים') }}</span>
                  <span>{{ usage.documents_used }} / {{ usage.documents_limit }}</span>
                </div>
                <div class="ump-usage__bar">
                  <div
                    class="ump-usage__fill"
                    [style.width.%]="usagePercent(usage.documents_used, usage.documents_limit)">
                  </div>
                </div>
                <small>{{ curentLang === 'en' ? 'Remaining' : (curentLang === 'ar' ? 'متبقي' : 'נותר') }}: {{ v2SubscriptionStatus.documents_remaining ?? 0 }}</small>
              </div>
              <div class="ump-usage__row">
                <div class="ump-usage__head">
                  <span>{{ curentLang === 'en' ? 'Companies' : (curentLang === 'ar' ? 'المصالح التجارية' : 'חברות') }}</span>
                  <span>{{ usage.companies_used }} / {{ usage.companies_limit }}</span>
                </div>
                <div class="ump-usage__bar">
                  <div
                    class="ump-usage__fill ump-usage__fill--secondary"
                    [style.width.%]="usagePercent(usage.companies_used, usage.companies_limit)">
                  </div>
                </div>
                <small>{{ curentLang === 'en' ? 'Remaining' : (curentLang === 'ar' ? 'متبقي' : 'נותר') }}: {{ v2SubscriptionStatus.companies_remaining ?? 0 }}</small>
              </div>
            </div>
          </ng-container>

          <div class="ump-payment-link" *ngIf="v2SubscriptionStatus?.latest_pending_admin_payment_link">
            <label>{{ curentLang === 'en' ? 'Pending payment link' : (curentLang === 'ar' ? 'رابط دفع معلّق' : 'קישור תשלום ממתין') }}</label>
            <div class="ump-payment-link__row">
              <input class="ump-input" [value]="v2SubscriptionStatus.latest_pending_admin_payment_link" readonly />
              <button type="button" class="ump-btn ump-btn--icon" (click)="copyPendingPaymentLink(v2SubscriptionStatus.latest_pending_admin_payment_link)" title="Copy">
                <i class="fa fa-copy"></i>
              </button>
              <a
                class="ump-btn ump-btn--icon"
                [href]="v2SubscriptionStatus.latest_pending_admin_payment_link"
                target="_blank"
                rel="noopener noreferrer"
                title="Open">
                <i class="fa fa-external-link"></i>
              </a>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </section>
  </div>
</div>
